import { Row } from '@components/Layout/Row';
import Typography from '@material-ui/core/Typography';
import BrokenImage from '@material-ui/icons/BrokenImage';
import { createMemo } from '@packages/react';
import React, { useMemo } from 'react';

export enum LAZY_IMAGE_ERROR {
    NONE,
    NO_IMAGE,
    NO_NETWORK,
    NOT_FOUND,
}

interface ILazyImageError {
    reason: LAZY_IMAGE_ERROR;
    noMessage?: boolean;
}

export const LazyImageError = createMemo<ILazyImageError>(
    ({ noMessage, reason }) => {
        const data$ = useMemo(() => {
            const data = {
                icon: <BrokenImage color={'disabled'} />,
                text: "Image couldn't be loaded!",
            };

            switch (reason) {
                case LAZY_IMAGE_ERROR.NO_IMAGE:
                    data.text = "There's no image!";
                    break;
                case LAZY_IMAGE_ERROR.NO_NETWORK:
                    data.text = "Looks like there's no network connection!";
                    break;
            }

            return data;
        }, [reason]);

        return (
            <Row justify={'center'} align={'center'} layout={'column'}>
                {data$.icon}
                {!noMessage ? (
                    <Typography
                        variant={'caption'}
                        color={'textSecondary'}
                        display={'inline'}
                        noWrap
                        title={data$.text}
                        style={{ marginTop: 6 }}
                    >
                        {data$.text}
                    </Typography>
                ) : null}
            </Row>
        );
    },
    {
        displayName: 'LazyImageError',
    },
);
